import { render, staticRenderFns } from "./InsuranceBenefitAddModal.vue?vue&type=template&id=6887d34d&scoped=true"
import script from "./InsuranceBenefitAddModal.vue?vue&type=script&lang=js"
export * from "./InsuranceBenefitAddModal.vue?vue&type=script&lang=js"
import style0 from "./InsuranceBenefitAddModal.vue?vue&type=style&index=0&id=6887d34d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887d34d",
  null
  
)

export default component.exports